import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@/components/container.tsx';
import { Companies } from '@/components/companies.tsx';
import { Features } from '@/components/features';
import { GridFeatures } from '@/components/grid-features.tsx';
import { NavBar } from '@/components/navbar';
import { Footer } from '@/components/SiteFooter';
import { HeroScrollDemo } from '@/components/ui/hero-scroll-demo.tsx';
import { CTA } from '@/components/cta.tsx';
import { GlowBackground } from '@/components/GlowBackground';
import SEOHelmet from '@/components/SEOHelmet';

declare global {
  interface Window {
    Vimeo?: {
      Player: any;
    };
  }
}

const Index = () => {
  const { t, i18n } = useTranslation('common');

  return (
    <div className="relative overflow-hidden">
      <SEOHelmet path="/" />
      <NavBar />
      <GlowBackground colorScheme={['green', 'blue', 'orange', 'purple']} />

      <div className="relative w-full">
        <HeroScrollDemo />
      </div>
      <Container className="flex flex-col items-center justify-between py-8 md:py-12">
        <div className="w-full overflow-x-hidden">
          <Companies />
        </div>
        <div className="w-full mt-8 md:mt-16">
          <Features />
        </div>
      </Container>
      <Container className="">
        <div className="w-full">
          <GridFeatures />
        </div>
        <div className="w-full ">
          <CTA />
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default Index;
